
import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import {ClientTrackingRoutes  } from '../../../routes';

export const ClientTrackingLayout = () => (
  <>
    <SwitchRoute routes={ClientTrackingRoutes} />
  </>
);
